import { StrictMode, startTransition } from 'react'
import './index.css'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './i18n'

const root = createRoot(document.getElementById('root')!)

// startTransition marks the initial render as non-urgent,
// allowing the browser to paint the skeleton/shell first
startTransition(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
